var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSeries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21420_68353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6 1C7.90261 1 6.27475 1.65555 5.07452 2.82245C3.87428 3.98934 3.2 5.57199 3.2 7.22222C3.2 8.87246 3.87428 10.4551 5.07452 11.622C6.27475 12.7889 7.90261 13.4444 9.6 13.4444C11.2974 13.4444 12.9253 12.7889 14.1255 11.622C15.3257 10.4551 16 8.87246 16 7.22222H14.4C14.4 9.80444 12.256 11.8889 9.6 11.8889C8.32696 11.8889 7.10606 11.3972 6.20589 10.5221C5.30571 9.64688 4.8 8.4599 4.8 7.22222C4.8 5.98455 5.30571 4.79756 6.20589 3.92239C7.10606 3.04722 8.32696 2.55556 9.6 2.55556C9.944 2.55556 10.288 2.59444 10.616 2.66444L11.904 1.42C11.168 1.14 10.4 1 9.6 1ZM14.872 2.22889L9.6 7.35444L7.696 5.50333L6.568 6.60778L9.6 9.55556L16 3.33333M2.344 3.97111C1.61258 4.55441 1.02307 5.28793 0.617794 6.11899C0.212521 6.95005 0.00154068 7.85804 0 8.77778C0 10.428 0.674284 12.0107 1.87452 13.1776C3.07475 14.3444 4.70261 15 6.4 15C6.912 15 7.416 14.9378 7.904 14.8211C6.496 14.5178 5.2 13.8333 4.136 12.8922C3.36989 12.4937 2.72939 11.9005 2.28277 11.176C1.83616 10.4514 1.60018 9.62251 1.6 8.77778C1.6 8.54444 1.624 8.31889 1.656 8.08556C1.624 7.79778 1.6 7.51 1.6 7.22222C1.6 6.10222 1.856 4.99 2.344 3.97111Z",
    fill: "#6200EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21420_68353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeries);
export default __webpack_public_path__ + "static/media/Series.1d4cdcac0982155ecae68d761baa2843.svg";
export { ForwardRef as ReactComponent };